import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import Loading from '../components/Loader'


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const steps = ['Farm/Producer Data', 'Processing/Manufacturing Data', 'Transportation Data', 'Warehouse/Storage Data'];

export default function HorizontalLinearStepper() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [farmertype, setfarmertype] = React.useState("none");
  const [loader, setloader] = React.useState(false);
  const [carriertype, setcarriertype] = React.useState("none");
  const [warehouse, setwarehouse] = React.useState("none");
  const [producttype, setproducttype] = React.useState("none");
  const [skipped, setSkipped] = React.useState(new Set());
  const [personName, setPersonName] = React.useState([]);

  const names = [
    "Forklifts",
    "Pallet jacks",
    "Conveyors",
    "Automated guided vehicles (AGVs)",
    "Sorting systems"
  ];


  const isStepOptional = (step) => {
    return step === 1;
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  


  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = (
                <></>
            //   <Typography variant="caption">Optional</Typography>
            );
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
            All steps completed - you&apos;re finished
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography>

        {
            activeStep===0?
            <div> 



        <TextField
          id="outlined-select-currency-native"
          select
          label="Product Processed"
          value={producttype}
          onChange={(e)=>setproducttype(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
        
            <option key="none" value="none">Choose  </option>
            <option key="Farmer" value="Farmer">Farmer  </option>
            <option key="Hauller / Agent" value="Female">Hauller / Agent  </option>
      
        </TextField> 

        <TextField
          id="quantity"
          label="Quantity Processed"
          type="number"
          autoComplete="current-text"
          InputProps={{
            endAdornment: <InputAdornment position="end">Tons</InputAdornment>,
          }}
        /> 

        <TextField
          id="outlined-select-currency-native"
          select
          label="Producer Type"
          value={farmertype}
          onChange={(e)=>setfarmertype(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
        
            <option key="none" value="none">Choose  </option>
            <option key="Farmer" value="Farmer">Farmer  </option>
            <option key="Hauller / Agent" value="Female">Hauller / Agent  </option>
      
        </TextField> 



        <FormControl sx={{ m: 1, width: 225 }}>

<InputLabel id="demo-multiple-checkbox-label">Choose Producer(s)</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          // id="outlined-select-currency-native"
          // label="Equipment"
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput label="Choose Producer(s)" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={personName.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>

        </FormControl>
          
          <Divider/>
<Typography>Producers' Details</Typography>

{personName.map((name)=>
<div>

<TextField
          id={name+"name"}
        //   label="Quantity Processed"
        //   type="number"
          value={name}
          disabled
          autoComplete="current-text"
          
        /> 

  <TextField
          id={name+"quantity"}
          label="Quantity Contributed"
          type="number"
          autoComplete="current-text"
          InputProps={{
            endAdornment: <InputAdornment position="end">Tons</InputAdornment>,
          }}
        /> 

<TextField
          id={name+"harvest"}
          label="Harvest Date"
          type="date"
        //   autoComplete="current-text"
        InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
          }}
          
        /> 
</div>
)
}


            </div> 
            :  activeStep===1 ?
            <div>
            
            <TextField
          id="batchnumber"
          label="Batch Number"
          type="text"
        //   autoComplete="current-text"
          
        /> 
         <TextField
          id="productiondate"
          label="Production Date"
          type="date"
          InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
          }}
        //   autoComplete="current-text"
          
        /> <TextField
          id="machines"
          label="Tools for production"
          type="text"
        //   autoComplete="current-text"
          
        />  <TextField
          id="type"
          label="Processing Type"
          type="text"
        //   autoComplete="current-text"
          
        /> 
          <TextField
          id="expirydate"
          label="Expiry Date"
          type="date"
          InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
          }}
        //   autoComplete="current-text"
          
        />
        <TextField
          id="quantityproduced"
          label="Quantity Produced"
          type="number"
          autoComplete="current-text"
          InputProps={{
            endAdornment: <InputAdornment position="end">Tons</InputAdornment>,
          }}
        /> 
            </div>:
            activeStep===2 ?
            <div> 
                
                <TextField
          id="outlined-select-currency-native"
          select
          label="Transport Type"
          value={carriertype}
          onChange={(e)=>setcarriertype(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
        
            <option key="none" value="none">Choose  </option>
            <option key="Vehicle" value="Vehicle">Vehicle  </option>
            <option key="Sea Cargo" value="Sea Cargo">Sea Cargo  </option>
            <option key="Air Cargo" value="Air Cargo">Air Cargo  </option>
            <option key="Rail" value="Rail">Rail  </option>
      
        </TextField>  

        <TextField
          id="bill"
          label="Bills of lading"
          type="text"
        //   autoComplete="current-text"
          
        />
        <TextField
          id="bill"
          label="Proof Of Delivery"
          type="text"
        //   autoComplete="current-text"
          
        />
            </div>:
            activeStep===3 ?
            <div>
        <TextField
          id="receivingdate"
          label="Receiving Date"
          type="date"
          InputProps={{
            startAdornment: <InputAdornment position="start"> </InputAdornment>,
          }}
        //   autoComplete="current-text"
          
        />
 <TextField
          id="outlined-select-currency-native"
          select
          label="Select Warehouse"
          value={warehouse}
          onChange={(e)=>setwarehouse(e.target.value)}
          slotProps={{
            select: {
              native: true,
            },
          }}
        //   helperText="Please select category"
        >
        
            <option key="none" value="none">Choose  </option>
            <option key="Vehicle" value="Vehicle">Vehicle  </option>
            <option key="Sea Cargo" value="Sea Cargo">Sea Cargo  </option>
            <option key="Air Cargo" value="Air Cargo">Air Cargo  </option>
            <option key="Rail" value="Rail">Rail  </option>
      
        </TextField>  
       
        <TextField
          id={"quantitystored"}
          label="Quantity Stored"
          type="number"
          autoComplete="current-text"
          InputProps={{
            endAdornment: <InputAdornment position="end">Tons</InputAdornment>,
          }}
        /> 

            </div>:
            
            <div></div>
        }

          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            <Box sx={{ flex: '1 1 auto' }} />
            {isStepOptional(activeStep) && (
              <>
              {/* <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                Skip
              </Button> */}
              </>
            )}
            
              {activeStep === steps.length - 1 ? <div>

                <div style={{marginTop:2, textAlign:"center"}}>    
            { loader? <Button  variant="outlined" startIcon={<Loading />} disabled >Loading...</Button>:
              <Button  variant="outlined" startIcon={<Loading />} size={"large"} >Submit New Process</Button>}
        </div>

              </div> : <Button onClick={handleNext}> Next </Button>}
           
          </Box>
        </React.Fragment>
      )}
    </Box>
  );
}
